import React, { useState } from "react";
import styled from "styled-components";
import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import SEO from "../components/SEO";
import { LocalBusinessSchema } from "../data/LocalBusinessSchema";

const AccueilContainer = styled.div`
  flex: 1; /* Make container fill available vertical space */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center content vertically */
  padding: 20px;
  text-align: center;
`;

const MainTitle = styled.h1`
  font-size: 48px;
  color: #13519a;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 10px;
  font-weight: normal;

  @media (max-width: 800px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.p`
  font-size: 22px;
  color: #5eb7ef;
  margin-bottom: 30px; /* Reduced margin */
  font-weight: 200;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const CarouselContainer = styled.div`
  max-width: 900px;
  margin: auto;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  overflow: hidden;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 350px;

  @media (max-width: 768px) {
    height: 250px;
  }
`;

const CarouselImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: ${props => props.$position || 'center center'};
  border: 5px solid #ddd;
  box-sizing: border-box;
`;

const ZoomButton = styled.button`
  position: absolute;
  bottom: 15px;
  right: 60px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, background 0.2s;

  &:hover {
    transform: scale(1.1);
    background: rgba(255, 255, 255, 0.25);
  }
`;

const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  cursor: pointer;
`;

const LightboxImage = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
`;

const CloseButton = styled.button`
  position: absolute;
  bottom: 30px;
  right: 30px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  cursor: pointer;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, background 0.2s;

  &:hover {
    transform: scale(1.1);
    background: rgba(255, 255, 255, 0.25);
  }
`;

const ActionButton = styled(Link)`
  display: block; /* Change to block */
  width: 100%; /* Make full width */
  max-width: 900px; /* Align with carousel */
  margin-left: auto; /* Center the block */
  margin-right: auto; /* Center the block */
  box-sizing: border-box; /* Include padding in width */
  margin-top: 30px; /* Reduced margin */
  padding: 15px 35px;
  font-size: 20px;
  font-weight: 400;
  color: white;
  background: linear-gradient(to right, #13519a, #5eb7ef);
  border-radius: 5px;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }
`;

const Accueil = () => {
  const [lightboxImage, setLightboxImage] = useState(null);

  const openLightbox = (src) => {
    setLightboxImage(src);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };

  return (
    <AccueilContainer>
      <SEO
        title="Accueil | ImpactIsol - Expert Calorifuge & Isolation Thermique"
        description="ImpactIsol : votre partenaire en calorifugeage et isolation thermique industrielle. Chantiers industrie, tertiaire et habitat en Auvergne-Rhône-Alpes."
        jsonLd={LocalBusinessSchema}
      />
      <MainTitle>Expert en Calorifuge pour des Réseaux <br /> Performants, Protégés et Durables.</MainTitle>
      <Subtitle>L'exigence technique pour vos chantiers Industrie, Tertiaire et Habitat.</Subtitle>

      <CarouselContainer>
        <Carousel
          autoPlay
          infiniteLoop
          showThumbs={false}
          showStatus={false}
          interval={6000}
          transitionTime={600}
        >
          {/* <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/calorifugeage-eau-glacee-annemasse.webp"} alt="Calorifugeage des tuyauteries d'eau glacée en local technique – Annemasse" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/calorifugeage-eau-glacee-annemasse.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div> */}
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/isolation-reseau-vmc-double-flux.webp"} alt="Isolation d'un réseau de VMC double flux – habitat" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/isolation-reseau-vmc-double-flux.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          {/* <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/reseaux-eau-glacee-exterieurs-groupe-froid.webp"} alt="Réseaux d'eau glacée extérieurs calorifugés en sortie de groupe froid" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/reseaux-eau-glacee-exterieurs-groupe-froid.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div> */}
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/calorifugeage-tuyauteries-chaufferie.webp"} alt="Calorifugeage des tuyauteries et collecteurs d'une chaufferie" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/calorifugeage-tuyauteries-chaufferie.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/isolation-reseau-eau-glacee-exterieur.webp"} alt="Isolation d'un réseau d'eau glacée extérieur – tertiaire" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/isolation-reseau-eau-glacee-exterieur.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/calorifuge-gaines-ecole-saint-martin-uriage.webp"} alt="Calorifuge de réseaux de gaines – école de Saint-Martin-d'Uriage (38)" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/calorifuge-gaines-ecole-saint-martin-uriage.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/calorifugeage-cuve-industrielle-sur-mesure.webp"} alt="Calorifugeage sur mesure d'une cuve industrielle sur chantier" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/calorifugeage-cuve-industrielle-sur-mesure.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/calorifugeage-habillage-cheminee-industrielle.webp"} alt="Calorifugeage et habillage métallique d'une cheminée industrielle" $position="center 38%" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/calorifugeage-habillage-cheminee-industrielle.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/calorifugeage-cyclo-filtre-industrie.webp"} alt="Calorifugeage d'un cyclo-filtre – site industriel" $position="center 22%" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/calorifugeage-cyclo-filtre-industrie.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/calorifugeage-chaufferie-eglise-smh-oddos.webp"} alt="Calorifugeage de chaufferie – église, SMH Oddos" $position="center 68%" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/calorifugeage-chaufferie-eglise-smh-oddos.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/isolation-groupe-froid-le-froid-nicois.webp"} alt="Isolation des tuyauteries d'un groupe frigorifique – Le Froid Niçois" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/isolation-groupe-froid-le-froid-nicois.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/isolation-froid-positif-schiever-sennecey.webp"} alt="Isolation des réseaux de froid positif – Schiever, Sennecey" $position="center 68%" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/isolation-froid-positif-schiever-sennecey.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
          <div>
            <ImageWrapper>
              <CarouselImage src={process.env.PUBLIC_URL + "/images/calorifugeage-chaufferie-biomasse-passy.webp"} alt="Calorifugeage des réseaux de la chaufferie biomasse de Passy (74)" />
              <ZoomButton onClick={() => openLightbox(process.env.PUBLIC_URL + "/images/calorifugeage-chaufferie-biomasse-passy.webp")} aria-label="Agrandir l'image">⤢</ZoomButton>
            </ImageWrapper>
          </div>
        </Carousel>
      </CarouselContainer>

      <ActionButton to="/societe">Découvrir notre société</ActionButton>

      {lightboxImage && (
        <LightboxOverlay onClick={closeLightbox}>
          <LightboxImage src={lightboxImage} alt="Image agrandie" onClick={(e) => e.stopPropagation()} />
          <CloseButton onClick={closeLightbox} aria-label="Fermer">⤡</CloseButton>
        </LightboxOverlay>
      )}
    </AccueilContainer>
  );
};

export default Accueil;
